import { AbstractGetAllStore } from "../common/AbstractStores";
import { TipoContratto } from "../generated";
import Dispatcher from "../common/dispatcher";
import TipiContrattoActions from "./tipiContrattoActions";

class TipiContrattoStore extends AbstractGetAllStore<TipoContratto>{
    constructor() {
        super(x => x.id);
        Dispatcher
            .onfunction(TipiContrattoActions.getAll, result => this.setAll(result))
            .onfunction(TipiContrattoActions.add, result => this.setAll(result))
            .onfunction(TipiContrattoActions.update, result => this.setAll(result))
    }
    public useAll = () => this.useAllWithAction(() => TipiContrattoActions.getAll())
}

export default new TipiContrattoStore()
